export default {
  workspace_health: "Workspace Health",
}
